
import api from './api';

// Serviços específicos para checkout
export const checkoutService = {
    // Calcular frete usando a API do backend
    async calculateShipping(cepDestino, peso) {
        try {
            const response = await api.get('products/public/calculate-shipping', {
                params: {
                    cep_destino: cepDestino,
                    peso: peso
                }
            });
            return response.data;
        } catch (error) {
            console.error('Erro ao calcular frete:', error);
            throw error;
        }
    },

    // Criar pedido público
    async createPublicOrder(orderData) {
        try {
            const response = await api.post('orders/public/create', orderData);
            return response;
        } catch (error) {
            console.error('Erro ao criar pedido:', error);
            throw error;
        }
    },

    // Buscar pedido por ID
    async getOrderById(orderId) {
        try {
            const response = await api.get(`orders/public/${orderId}`);
            return response;
        } catch (error) {
            console.error('Erro ao buscar pedido:', error);
            throw error;
        }
    },

    // Criar pedido
    async createOrder(orderData) {
        try {
            const response = await api.post('orders', orderData);
            return response;
        } catch (error) {
            console.error('Erro ao criar pedido:', error);
            throw error;
        }
    },

    // Criar intenção de pagamento
    async createPaymentIntent(paymentData) {
        try {
            const response = await api.post('payments/create-intent', paymentData);
            return response;
        } catch (error) {
            console.error('Erro ao criar intenção de pagamento:', error);
            throw error;
        }
    },

    // Buscar CEP (usando ViaCEP como fallback)
    async getAddressByCep(cep) {
        try {
            // Primeiro tenta usar a API própria
            const response = await api.get(`addresses/cep/${cep}`);
            return response;
        } catch (error) {
            console.log('API própria falhou, usando ViaCEP como fallback');

            // Fallback para ViaCEP
            const cleanCep = cep.replace(/\D/g, '');
            const viaCepResponse = await fetch(`https://viacep.com.br/ws/${cleanCep}/json/`);
            const viaCepData = await viaCepResponse.json();

            if (viaCepData.erro) {
                throw new Error('CEP não encontrado');
            }

            return viaCepData;
        }
    }
};

export default checkoutService;
